export const fontConfig = {
  Roboto: [
    {
      weight: 100,
      style: "normal",
      file: "Roboto-Thin.ttf",
      className: "roboto-thin"
    },
    {
      weight: 100,
      style: "italic",
      file: "Roboto-ThinItalic.ttf",
      className: "roboto-thin-italic"
    },
    {
      weight: 300,
      style: "normal",
      file: "Roboto-Light.ttf",
      className: "roboto-light"
    },
    {
      weight: 300,
      style: "italic",
      file: "Roboto-LightItalic.ttf",
      className: "roboto-light-italic"
    },
    {
      weight: 400,
      style: "normal",
      file: "Roboto-Regular.ttf",
      className: "roboto-regular"
    },
    {
      weight: 400,
      style: "italic",
      file: "Roboto-Italic.ttf",
      className: "roboto-italic"
    },
    {
      weight: 500,
      style: "normal",
      file: "Roboto-Medium.ttf",
      className: "roboto-medium"
    },
    {
      weight: 500,
      style: "italic",
      file: "Roboto-MediumItalic.ttf",
      className: "roboto-medium-italic"
    },
    {
      weight: 700,
      style: "normal",
      file: "Roboto-Bold.ttf",
      className: "roboto-bold"
    },
    {
      weight: 700,
      style: "italic",
      file: "Roboto-BoldItalic.ttf",
      className: "roboto-bold-italic"
    },
    {
      weight: 900,
      style: "normal",
      file: "Roboto-Black.ttf",
      className: "roboto-black"
    },
    {
      weight: 900,
      style: "italic",
      file: "Roboto-BlackItalic.ttf",
      className: "roboto-black-italic"
    }
  ]
};
export const defaultFontFamily = "Roboto";

export const fontVariantClasses = {
  variant1: {
    regular: "font-roboto-regular web:font-normal",
    italic: "font-roboto-italic web:font-normal web:italic",
    bold: "font-roboto-bold web:font-bold",
    boldItalic: "font-roboto-boldItalic web:font-bold web:italic",
    light: "font-roboto-light web:font-light",
    lightItalic: "font-roboto-light-italic web:font-light web:italic",
    medium: "font-roboto-medium web:font-medium",
    mediumItalic: "font-roboto-medium-italic web:font-medium web:italic",
    thin: "font-roboto-thin web:font-thin",
    thinItalic: "font-roboto-thin-italic web:font-thin web:italic",
    black: "font-roboto-black web:font-bold",
    blackItalic: "font-roboto-black-italic web:font-bold web:italic"
  }
};
